<template>
  <div>
    <md-card-content>
      <div class="table-header-info">
        <div>총 {{ total }} 건</div>
        <div v-if="!hidePerpageOption" style="text-align: right;">
          회원명 <input type="text" style="width:100px;" v-model="cCustNm"> <md-button class="md-info md-sm" @click="sendQuery()" style="margin-right: 10px; vertical-align: middle;"><md-icon>check</md-icon>검 색</md-button>
          <select v-model="pagination.perPage" name="pages" @change="perPageChange" style="width: auto;">
            <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
        <div v-if="hidePerpageOption">
          회원명 <input type="text" style="width:100px; vertical-align: middle; width: 100px;" v-model="cCustNm"> <md-button class="md-info md-sm" @click="sendQuery()" style="margin-right: 10px; vertical-align: middle;"><md-icon>check</md-icon>검 색</md-button>
          상태별 보기
          <select v-model="searchCallCd" style="width: auto;" @change="sendQuery()">
            <option selected value="">전체</option>
            <option v-for="item in campaignCd1List"
                    :key="item.code"
                    :value="item.code"
                    :label="item.codeNm"
            ></option>
          </select>
        </div>
      </div>
      <grid ref="cmpMemberListGrid" v-if="!isRadio"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :theme="gridProps.theme"
            :rowHeaders="gridProps.rowHeaders"
            :columnOptions="gridProps.columnOptions"
            :language="gridProps.lang"
            @response="response"
      ></grid>
      <grid ref="cmpMemberListGrid" v-if="isRadio"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :theme="gridProps.theme"
            :rowHeaders="gridProps.rowHeaders"
            :columnOptions="gridProps.columnOptions"
            :language="gridProps.lang"
            @click="onClickMember"
            @response="response">
       </grid>
    </md-card-content>
    <slot name="bottomRightArea"></slot>
  </div>
</template>
<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";
import Swal from "sweetalert2";
import moment from "moment";

import { Grid } from '@toast-ui/vue-grid';

export default {
  name: "cmpTargetListComp",
  props: {
    isRadio : {
      type: Boolean,
      default: false
    },
    isCalling : {
      type: Boolean,
      default: false
    },
		hidePerpageOption  : {
      type: Boolean,
      default: false
    }
  },
  components: {
    grid: Grid
  },

  created() {
    this.queryCampaignCd1List();
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      campaignCd1List : [],
      searchCallCd : null,
      cCustNm : null,
      cCmpId : null,
      gridProps: {},
      pagination: {
        perPage: this.hidePerpageOption ? 15 : 50,
        page: 1,
        perPageOptions: [15, 50, 100, 200, 500],
        total: 0
      },
    };
  },
  methods: {
    queryCampaignCd1List() {
      kuaaFnc.fncCmpCallTypes(null,res => {
        this.campaignCd1List = res.data.data.contents;
      });
    },
    sendQuery (cCmpId,cAgentId){
      if(cCmpId){
        this.cCmpId = cCmpId;
      }
      let params = {cCmpId:this.cCmpId, cCustNm : this.cCustNm, result : this.searchCallCd}
      if(cAgentId){
        params['cAgentId'] = cAgentId;
        }
      this.$refs.cmpMemberListGrid.invoke("readData", this.$refs.cmpMemberListGrid.invoke("getPagination")._currentPage, params);
    },
    resetData(){
      this.$refs.cmpMemberListGrid.invoke("clear");
    },
    initGrid() {

      if(!this.isRadio){
        this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_CMP_RESULT_LIST, false, this.pagination, ['rowNum','checkbox']);
        this.gridProps['el'] = this.$refs.cmpMemberListGrid;
        this.gridProps['columns'] = [
          {header: '교우번호', name: 'cCustId', align : 'center', sortable: true},
          {header: '교우명', name: 'cCustNm', align : 'center', sortable: true},
          {header: '대학,학과', name: 'cCustInfo', align : 'center', sortable: true},
          {header: '휴대폰', name: 'cMobileTel', align : 'center', sortable: true},
          {header: '집전화', name: 'cHomeTel', align : 'center', sortable: true},
          {header: '회사전화', name: 'cCompanyTel', align : 'center', sortable: true}
        ];
        this.gridProps['options'].bodyHeight = 300;
        
      }else{
        this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_CMP_RESULT_LIST, false, this.pagination);
        this.gridProps['el'] = this.$refs.cmpMemberListGrid;
        this.gridProps['columns'] = [
          // {
          //   header: null, name: null, align : 'center', width : 30,
          //   formatter(value) {
          //       return '<input type="radio" id="radio' + value.row.cCustId + '" name="selectedCCustId">';
          //   }
          // },
          {header: '상태', name: 'resultNm', align : 'center', sortable: true, width:60},
          {header: '교우번호', name: 'cCustId', align : 'center', sortable: true, width:80},
          {header: '교우명', name: 'cCustNm', align : 'center', sortable: true, width:80},
          {header: '휴대폰', name: 'cMobileTel', align : 'center', sortable: true, width:90},
          {header: '집전화', name: 'cHomeTel', align : 'center', sortable: true, width:90},
          {header: '회사전화', name: 'cCompanyTel', align : 'center', sortable: true, width:90}
        ];
        this.gridProps['options'].bodyHeight = this.hidePerpageOption ? 410 : 280;
      }
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.cmpMemberListGrid, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.$emit('returnRes', res.data.contents);
        this.pagination.total = res.data.pagination.totalCount;
        this.$refs.cmpMemberListGrid.invoke("refreshLayout");

        this.$refs.cmpMemberListGrid.on("focusChange", '5');

      }else{
        kuaaFnc.gridErrorCallback(e);
      }
    },
    getSelectedMember(){
      return this.$refs.cmpMemberListGrid.invoke('getCheckedRows');
    },
    onClickMember (item){
      if(item.instance.getRow(item.rowKey) != null) {
        let obj = item.instance.getRow(item.rowKey);
        if(obj.result == '00'){
          // 그리드 선택
          // document.getElementById('radio' + obj.cCustId).checked = true;
          this.$emit('returnResult', obj, item.columnName);
        }
        else{
        	this.$emit('returnResult', obj, item.columnName);
        }

        if(obj[item.columnName] && (item.columnName == 'cMobileTel' || item.columnName == 'cHomeTel' || item.columnName == 'cCompanyTel')){
          this.$emit('onClickPhone', obj[item.columnName]);
        }
      }
    }
  }
};
</script>

<style lang="css" scoped>
</style>